// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem, Label, Input, Col,
  Row, 
  Table} from "reactstrap";

import TableWithSortPagtnAndCheckBox from "../../common/TableWithSortPagtnAndCheckBox";
import ProcessDuty from "./ProcessDuty";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import ReactModal from 'react-modal';
import api from "../../../apis/api";
import Calendar from "react-calendar";
import { red } from "@material-ui/core/colors";
import "../../../style/processleave.css";
import SelectBoxSearch from "../../common/SelectBoxSearch";
import Notifications from "../../../components/common/Notifications";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth="80vw";
const ListProcessDuty = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    handledelAppliedLeaves,
    handelFromDate,
    handelToDate,
    myleavelist,
    handlerecholidayCalendarArray,
    handleleavestatus,
    employeelist,
    loadtask,
    selectedEmployeeId
  }) => {
    const [thead] = useState([
      "Id",
      "Name",
      "Type",
      "Applied",
      "DateFrom",
      "DateTo",
      "Days",
      "Status",
      "Action",

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
    const [leavelist,setleavelist]=useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [leaverequestDetails, setLeaverequestDetails] = useState([]);
    const [myleavedetailedlist,setmyleavelist]=useState([]);
    const [myappliedleavelist,setmyappliedleavelist]=useState([]);
    const [dateArray,setDateArray]=useState([]);
    const [comment,setcomment]=useState("");
    const [calenderDate] = useState(new Date());
    const [action ,setaction] =useState("");
    const [islistview,setislistview] =useState(true);
    const [isDetailedview,setdetailedview] =useState(false);
    const [error, setError] = useState(null);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
        const [selectedEmployeesString, setSelectedEmployeesString] = useState([]);
    const buttonStyles = {
      position: "absolute",
      top: "10px",
      right: "10px"
    };
    let holidaylist=[];
    handlerecholidayCalendarArray.map(function (hol){
    holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
  });

  let leavestatuslist=[];
  handleleavestatus.map(function (hol){
    leavestatuslist.push({value :hol.leaveStatusId,label :hol.status});
});
    useEffect(() => {
      setleavelist(empTask);

    },[empTask])
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

  //  const handledelAppliedleave =React.useCallback((leave) =>{
  //   delAppliedLeaves(leave);
  //  },[delAppliedLeaves])

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);
    const getDates = (arrlist) => {
      const dates = [];
      arrlist.forEach(element => {
        if (element.fromDate && element.toDate) {
          const start = new Date(element.fromDate);
          const end = new Date(element.toDate);
          const days = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          
          for (let i = 0; i <= days; i++) {
              const currentDate = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);
              dates.push(moment(currentDate).format("DD-MM-YYYY"));
          }
        
      }
      });
      setDateArray(dates);
  };
const handleDetails=React.useCallback((dutyrequestId,employeeId)=>{
  setIsOpen(true);
  const fetchApi = async () => {
    let arr=[];
    let arr1=[];
    let arr2=[];
    await api
    .dbduty()
    .GetDutyRequestById(parseInt(dutyrequestId))
    .then((res) =>setLeaverequestDetails(res.data));
    await api
    .dbLeaveTypes()
    .GetLeaveOrDutyTypesByEmpId(parseInt(employeeId),parseInt(1))
    .then((res) =>arr.push(res.data));
    
    await api
    .dbduty()
    .GetAppliedDutyByEmpId(parseInt(employeeId))
    .then((res) =>arr2.push(res.data));
  

    await api
    .dbduty()
    .GetAppliedDutyByRequestId(parseInt(dutyrequestId))
    .then((res) =>arr1.push(res.data));

    setmyleavelist(arr[0]);
    setmyappliedleavelist(arr1[0]);
    getDates(arr2[0]);
  }
  fetchApi();
  setislistview(false);
  setdetailedview(true);
})

    useEffect(() => {
      let sortedTasks = [...empTask].sort((a, b) => a.dutyRequestId - b.dutyRequestId);

      let trow = sortedTasks.map((el) => ({
        Id:<div style={{width:'20px'}}>{el.dutyRequestId}</div>,
        Name:<div style={{width:'100px'}}>{el.employeeName}</div>,
        Type:<div style={{width:'100px'}}>{el.type}</div>,
        Applied:<div style={{width:'100px'}}>{moment(el.createdOn).format("DD-MM-YYYY")}</div>,
        DateFrom:<div style={{width:'100px'}}>{moment(el.fromDate).format("DD-MM-YYYY")}</div>,
        DateTo:<div style={{width:'100px'}}>{moment(el.toDate).format("DD-MM-YYYY")}</div>,
        Days:<div style={{width:'100px'}}>{el.noOfDays}</div>,
        Status:<div style={{width:'100px'}}>{el.dutyStatus}</div>,
        Action:
          <Button
    color=""
    className="btn-admin-settings"
    onClick={() => handleDetails(el.dutyRequestId, el.employeeId)}
    data-id={el.dutyRequestId} // Pass ID as attribute
  >
    Process
  </Button>

      }));

      setTrow(trow);
    }, []);
    const onSelectionChange = (selectedIds) => {
      setSelectedEmployees(selectedIds);
      const childrenValues = selectedIds.map(item => item.props.children).join(",");
      setSelectedEmployeesString(childrenValues);
    };
     const handleApproveSelected= () =>{
    
            if (selectedEmployeesString.length === 0) {
              alert("No employees selected for approval.");
              return;
            }
      
            const fetchApi = async () => {
                   let arr=[];
                
                  const res= await api
                   .dbduty()
                   .ApproveAllDutyRequest(selectedEmployeesString,parseInt(1),comment);
                   if(res.status == 200)
                   {
                    setError({ ...error, message: "Duty Approve Successfully..", status: 200 });
                    setTimeout(() => { 
                      window.location.reload();
                     }, 3000);
                   }
                   
                 }
                 fetchApi();
        }
    return (
      <Fragment>
        <div className="row right">

<div className="col-md-6">
        <SelectBoxSearch
  options={employeelist}
  onChange={(e) => {
    loadtask(e); // Your existing logic
  }}
  selectedUser={selectedEmployeeId}
  placeholder="Select Employee"
/>
</div>
</div>
{islistview == true ?  (<div className="row right">

          <div className="col-md-3">
          <Label for="exampleEmail">From Date</Label>
                <Input
                  type="date"
                  // value={warrantyEndDate}
                  onChange={(e) => handelFromDate(e.target.value)}
                />
          </div>
          <div className="col-md-3">
          <Label for="exampleEmail">To Date</Label>
                <Input
                  type="date"
                  // value={warrantyEndDate}
                   onChange={(e) => handelToDate(e.target.value)}
                />
          </div>
          <div className="col-md-3 buttonalign" >
            <Label>   </Label>
<Button type="Button">Search</Button></div>
            &nbsp;

          </div>) : null }
       <br/>
     {islistview == true ? ( <div className="" style={{ maxWidth: maxwidth, overflowY: "auto" }}>
       {selectedEmployeesString !='' ? (<div style={{textAlign: "right", marginBottom: "10px"}}><Button onClick={handleApproveSelected} style={{ marginBottom: "10px",background:"white" }} className="btn-admin-settings btn btn btn-outline-secondary btn-sm">
                    Process Selected
                  </Button></div>) : (null)}
      <TableWithSortPagtnAndCheckBox thead={thead} trow={trow} pageSize={5} onSelectionChange={onSelectionChange}></TableWithSortPagtnAndCheckBox>
    </div>) : null}  
{isDetailedview == true ? ( <ProcessDuty
leaverequestDetails={leaverequestDetails}
myleavedetailedlist={myleavedetailedlist}
myappliedleavelist={myappliedleavelist}
handlerecholidayCalendarArray={handlerecholidayCalendarArray}
handleleavestatus={handleleavestatus}
empTask={empTask}
handleSelectedTask={handleSelectedTask}
handleDelTask={handleDelTask}
dateArray={dateArray}
></ProcessDuty>) : null}
   
       <Notifications notifications={error}></Notifications>
   
        {/* <div className="mt-3">
          <ListGroup className="task-list ">
            {empTask.map((tasks, i) => (
              <ListGroupItem
                key={i}
                onClick={() => handleOnclickSelectedTask(tasks, i)}
                style={i === activeTask ? active : null}
              >
                <div className="task-container ">
                  <span className="task-check">
                  {tasks.timeSheetStatus ==3 ? (<i className="fas fa-check  project-task-icon" style={{ color: 'green'}}></i>) : <i className="fas fa-check  project-task-icon"></i>}
                    
                  </span>
                  <span className="task-label">{tasks.description}</span>
                  <span className="task-label">{tasks.hoursSpent}</span>
                  <span className="task-label">{tasks.timeSheetStatus}</span>
                  <span className="task-action-btn task-btn-right">
                    <span
                      className="action-circle large task-assign"
                      title="Assign"
                    >
                      <i className="fas fa-user  project-task-icon"></i>
                    </span>
                    <span
                      className="action-circle large delete-btn"
                      title="Delete Task"
                      onClick={() => DelTask(tasks.employeeTimeSheetId)}
                    >
                      <i className="fas fa-trash project-task-icon"></i>
                    </span>
                  </span>
                </div>
              </ListGroupItem>
            ))}
          </ListGroup>
        </div> */}
      </Fragment>
    );
  }
);

export default ListProcessDuty;
